var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnipa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8341 67.9372L0 86.9955L7.51121 94.5067L12.3318 94.3946L80.4933 162.78V167.713L87.7803 175L140.919 122.085L106.502 87.4439L87.3318 106.614L102.578 121.861L87.5561 136.883L18.8341 67.9372Z",
    fill: "#00E3B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.166 107.063L175 88.0045L167.489 80.4933L162.668 80.6054L94.5067 12.2197V7.287L87.2197 0L34.0807 52.9148L68.4977 87.5561L87.6681 68.3857L72.4215 53.139L87.4439 38.1166L156.166 107.063Z",
    fill: "#00E3B4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnipa);
export default __webpack_public_path__ + "static/media/snipa.7c781cf1b4a26447ec8616fee4cc6a17.svg";
export { ForwardRef as ReactComponent };